import { Directive, ElementRef, HostListener, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[appAutoExpand]',
    standalone: false,
})
export default class AutoExpandDirective implements AfterViewInit {
    private maxHeight: number;

    /**
     *
     * @param el
     */
    constructor(private readonly el: ElementRef<HTMLTextAreaElement>) {}

    /**
     *
     */
    ngAfterViewInit() {
        const lineHeight = parseInt(getComputedStyle(this.el.nativeElement).lineHeight, 10);
        this.maxHeight = lineHeight * 3;
        this.adjustHeight();
    }

    /**
     *
     */
    @HostListener('input') onInput() {
        this.adjustHeight();
    }

    /**
     *
     */
    private adjustHeight(): void {
        const textarea = this.el.nativeElement;
        textarea.style.height = 'auto';
        const newHeight = Math.min(textarea.scrollHeight, this.maxHeight);
        if (textarea.value.length === 0) {
            return;
        }
        textarea.style.height = `${newHeight}px`;
    }
}
